import * as React from "react";
import { ReactNode } from "react";
import HeaderBar from "../commons/components/HeaderBar";
import "./PatientDashboard.scss";
import PatientSummary from "../patient-profile/PatientSummary";
import { PatientProfilePanel } from "./PatientProfilePanel";
import { AppointmentsPanel, AppointmentUrls } from "./AppointmentsPanel";
import MobileApplicationLink from "./MobileApplicationLink";
import MobileApplicationView from "./MobileApplicationView";
import Country from "../commons/model/address/Country";
import { createRoot } from "react-dom/client";

export interface Error {
  action: () => Promise<any>;
  title: string;
  content: ReactNode;
}

export default function PatientDashboard({
  patients,
  appointmentUrls,
  fetchPatientUrl,
  availableCountries,
  mobileApplicationView,
  allowAppointment,
}: {
  patients: PatientSummary[];
  appointmentUrls: AppointmentUrls;
  fetchPatientUrl: string;
  availableCountries: Country[];
  mobileApplicationView?: MobileApplicationView;
  allowAppointment: Boolean;
}) {
  return (
    <>
      <HeaderBar
        title={i18n["Page.Portal.PatientDashboard"]}
        action={
          mobileApplicationView && (
            <MobileApplicationLink mobileApplicationView={mobileApplicationView} />
          )
        }
      />
      <div className="container">
        <PatientProfilePanel
          patients={patients}
          fetchPatientUrl={fetchPatientUrl}
          availableCountries={availableCountries}
        />
        {allowAppointment && (
          <AppointmentsPanel
            {...appointmentUrls}
            title={"Page.Portal.PatientDashboard.Appointments.Title"}
          />
        )}
      </div>
    </>
  );
}

PatientDashboard.loadComponent = (elementId: string, props) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<PatientDashboard {...props} />);
};
